import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Scale } from 'lucide-react';
import { API } from '../../App';

export const TaxSetupCard = () => {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { axios.get(`${API}/tax-setup/status`).then((r) => setStatus(r.data)).catch(() => {}); }, []);
  if (!status?.supported) return null;
  return (
    <Card className="border-l-4 border-l-[#283F8B]" data-testid="tax-setup-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Scale className="w-5 h-5 text-[#283F8B]" /> Tax setup questionnaire
          <Badge variant={status.complete ? 'default' : 'destructive'} data-testid="tax-setup-card-status">{status.complete ? 'Complete' : `${status.percent}% · required`}</Badge>
        </CardTitle>
        <CardDescription>Country-specific registrations, schemes, thresholds and what you sell — the context the tax engine uses for every transaction. {status.completed_at ? `Last completed ${new Date(status.completed_at).toLocaleDateString()}.` : ''}</CardDescription>
      </CardHeader>
      <CardContent><Button variant="outline" onClick={() => navigate('/tax-setup?return=/settings?tab=tax')} data-testid="tax-setup-card-open">{status.complete ? 'Review answers' : 'Complete tax setup'}</Button></CardContent>
    </Card>
  );
};
